import React from 'react'
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import KlienciService from "../../KlienciService";
import Loading from "react-viewer/lib/Loading";
import moment from "moment";

export default class PokazOdbicia extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loader: true
        }

        this.renderData = this.renderData.bind(this)
    }

    componentDidMount() {
        KlienciService.getKlientKartaOdbicia(this.props.idKa).then((response) => {
            this.setState({data: response.data, loader: false})
        })
    }

    renderData(cell) {
        return moment(cell).format('YYYY-MM-DD HH:mm')
    }

    render() {
        return <div>{this.state.loader ? <div id={'simple-small-loader'}>
            <i className={'fa fa-spinner fa-spin'}></i>
        </div> : <div>
            <h3>Odbicia karty o numerze: {this.state.data[0].nrKarty}</h3>
            <BootstrapTable data={this.state.data} hover pagination
                            options={{noDataText: 'Brak pasujących rekordów', expandBy: 'column'}}>
                <TableHeaderColumn dataField='idKa' isKey hidden={true}>Id karty</TableHeaderColumn>
                <TableHeaderColumn dataField='nazTr' dataSort
                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                >Trasa</TableHeaderColumn>
                <TableHeaderColumn dataField='nazPr' dataSort
                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                >Przystanek</TableHeaderColumn>
                <TableHeaderColumn dataField='dataOdbicia' dataSort
                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                   dataFormat={this.renderData}
                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                >Data</TableHeaderColumn>
            </BootstrapTable></div>}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/modules/klienciConfig/stronaKlienta/components/PokazOdbicia.js